import styled from "styled-components";

const FONT_STACK = `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`;

export const BackButtonStyled = styled.button`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: ${FONT_STACK};
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--violetaOscuro);
  background: rgba(76, 4, 140, 0.06);
  border: 1px solid rgba(76, 4, 140, 0.18);
  border-radius: 8px;
  padding: 8px 14px 8px 10px;
  margin: 0 0 1rem 0;
  cursor: pointer;
  -webkit-font-smoothing: antialiased;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    transform 0.08s ease;

  svg {
    font-size: 1.05rem;
  }

  &:hover {
    background: rgba(76, 4, 140, 0.14);
    border-color: rgba(76, 4, 140, 0.32);
  }

  &:active {
    transform: scale(0.98);
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(203, 182, 219, 0.45);
  }
`;
